module.exports = __webpack_public_path__ + "media/images/video-d6ef782412fa8b26f8f12f57ba10e8a8.png";